import { createBrowserRouter } from 'react-router-dom';
import Layout from '../widgets/layout/Layout';
import NotFoundPage from '../pages/NotFound/NotFoundPage';
import AddCarsPage from '../pages/AddCarsPage/AddCarsPage';
import CarRegistryPage from '../pages/CarRegistryPage/CarRegistryPage';
import BrandPage from '../pages/BrandPage/BrandPage';
import WheelRegistryPage from '../pages/WheelRegistryPage/WheelRegistryPage';
import CreateWheelPage from '../pages/CreateWheelPage/CreateWheelPage';
import WheelDetailPage from '../pages/WheelDetailPage/WheelDetailPage';
import TyreRegistryPage from '../pages/TyreRegistryPage/TyreRegistryPage';
import OrdersPage from '../pages/OrdersPage/OrdersPage';
import OrderDetailPage from '../pages/OrderDetailPage/OrderDetailPage';
import TelegramAccountsPage from '../pages/TelegramAccountsPage/TelegramAccountsPage';
import LoginPage from '../pages/LoginPage/LoginPage';
import TyreDetailPage from '../pages/TyreDetailPage/TyreDetailPage';
import CreateTyrePage from '../pages/CreateTyrePage/CreateTyrePage';
import PortfolioRegistryPage from '../pages/PortfolioRegistryPage/PortfolioRegistryPage';
import PortfolioDetailPage from '../pages/PortfolioDetailPage/PortfolioDetailPage';
import MaxAccountsPage from '../pages/MaxAccountPage/MaxAccountsPage';

import ProtectedRoute from './ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <OrdersPage /> },
      { path: '/add-car', element: <AddCarsPage /> },
      { path: '*', element: <NotFoundPage /> },
      { path: '/car', element: <CarRegistryPage /> },
      { path: '/car/:brandId', element: <BrandPage /> },

      { path: '/wheels', element: <WheelRegistryPage /> },
      { path: '/wheels/create', element: <CreateWheelPage /> },
      { path: 'wheels/:id', element: <WheelDetailPage /> },

      { path: '/tyre', element: <TyreRegistryPage /> },
      { path: '/tyre/create', element: <CreateTyrePage /> },
      { path: 'tyre/:id', element: <TyreDetailPage /> },

      { path: '/orders', element: <OrdersPage /> },
      { path: '/orders/:id', element: <OrderDetailPage /> },
      { path: '/telegram', element: <TelegramAccountsPage /> },
      { path: '/max', element: <MaxAccountsPage /> },

      { path: '/portfolio', element: <PortfolioRegistryPage /> },
      { path: '/portfolio/create', element: <PortfolioDetailPage /> },
      { path: '/portfolio/:id', element: <PortfolioDetailPage /> },
    ],
  },
]);
